export const sortNotifications = (notifications) => [...notifications].sort((a, b) => Number(new Date(b.timestamp)) - Number(new Date(a.timestamp)));
